import React, { useEffect } from 'react';
import './App.css';
import HeroSection from './components/HeroSection';
import AnimatedImage from './components/AnimatedImage';
import PFPGenerator from './components/PFPGenerator';
import InfoSection from './components/InfoSection';
import Tokenomics from './components/Tokenomics';
import ChartModal from './components/ChartModal';

function App() {
  useEffect(() => {
    // Load Twitter widgets script
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    script.charset = 'utf-8';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="App">
      {/* Chart Modal */}
      <ChartModal />

      {/* Animated Image Container */}
      <AnimatedImage />

      {/* Hero Section */}
      <HeroSection />

      {/* Main Content */}
      <main className="content-section-wrapper">
        {/* PFP Generator Section */}
        <PFPGenerator />

        <div className="container main-content">
          {/* Info Section */}
          <InfoSection />

          {/* Tokenomics Section */}
          <Tokenomics />
        </div>
      </main>
    </div>
  );
}

export default App;
